module.exports = __webpack_public_path__ + "img/sv3.bb50249a.svg";